import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useMediaQuery,
  useTheme,
  CircularProgress
} from "@material-ui/core";

interface ConfirmationDialogProps {
  title: string;
  questionText: string;
  cancelActionText?: string;
  confirmActionText?: string;
  isOpen: boolean;
  isLoading: boolean;
  handleClose: React.Dispatch<React.SetStateAction<boolean>>;
  onConfirm: (event: React.MouseEvent<unknown>) => void;
}

function ConfirmationDialog({
  isOpen,
  isLoading,
  handleClose,
  onConfirm,
  title,
  questionText,
  cancelActionText,
  confirmActionText
}: ConfirmationDialogProps) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{questionText}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            autoFocus
            onClick={() => handleClose(false)}
            color="primary"
          >
            {cancelActionText || "Cancel"}
          </Button>
          <Button
            onClick={event => onConfirm(event)}
            color="primary"
            variant="text"
            autoFocus
            disabled={isLoading}
            startIcon={isLoading && <CircularProgress size="1rem" />}
          >
            {confirmActionText || "Confirm"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default ConfirmationDialog;
